import React from 'react';
import { Button } from '../ui/button';

interface AccountLoadErrorCardProps {
  /** May return a React Query refetch promise; errors should surface via query state, not this handler. */
  onRetry: () => void | Promise<unknown>;
  fullScreen?: boolean;
  /** Defaults to the standard account/org load copy. */
  title?: string;
  /** Defaults to the standard account/org load copy. */
  description?: React.ReactNode;
}

/**
 * Shared fallback when account/org state cannot be resolved.
 * Keep wording and CTA consistent across route guards.
 */
export const AccountLoadErrorCard: React.FC<AccountLoadErrorCardProps> = ({
  onRetry,
  fullScreen = false,
  title = "Couldn't load your account",
  description = (
    <>We couldn&apos;t load your organization profile. Check your connection and try again.</>
  ),
}) => {
  const containerClass = fullScreen
    ? 'flex flex-col items-center justify-center min-h-screen p-4 bg-muted/30'
    : 'flex flex-col items-center justify-center min-h-[40vh] p-4';

  return (
    <div className={containerClass}>
      <div className='max-w-md w-full bg-background rounded-lg border border-border shadow-lg p-8 text-center'>
        <h3 className='text-lg font-medium text-foreground mb-2'>{title}</h3>
        <div className='text-sm text-muted-foreground mb-6 text-center'>{description}</div>
        <div className='flex justify-center'>
          <Button
            type='button'
            onClick={() => {
              const result = onRetry();
              if (result instanceof Promise) {
                result.catch(() => undefined);
              }
            }}
            variant='default'
          >
            Try again
          </Button>
        </div>
      </div>
    </div>
  );
};
